import { render, staticRenderFns } from "./UserAchievements.vue?vue&type=template&id=55c8a6d4&scoped=true"
import script from "./UserAchievements.vue?vue&type=script&lang=ts"
export * from "./UserAchievements.vue?vue&type=script&lang=ts"
import style0 from "./UserAchievements.vue?vue&type=style&index=0&id=55c8a6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c8a6d4",
  null
  
)

export default component.exports